import { haveRole } from '@/lib/admin/getIsUserBackOffice'
import { ROLES_SOUND_ADMIN_ALL } from '@/types/enum/constants'

const getIsUserAdminSoundBackOffice = (loggedUserRoles: string[]): boolean =>
  haveRole(loggedUserRoles, ROLES_SOUND_ADMIN_ALL)

export default getIsUserAdminSoundBackOffice
